/* SHKRELI · Startseite („Alpengrün“), alle Märkte (geladen über snippets/at-head.liquid).
   (1) Uhr mit Ortszeit aus data-at-tz (Albanien Europe/Tirane, Österreich Europe/Vienna; Standard Europe/Vienna) –
       Quarz-Takt: Sekundenzeiger springt 1×/s (kurze CSS-Transition),
       pausiert bei verstecktem Tab / außerhalb des Viewports; reduzierte Bewegung = ohne Sekundenzeiger.
   (2) Fortschrittslinie der Reihen (Ausgewählte Uhren, Quarz-Modelle)  (3) Marker „Im Detail“  (4) Spotlight: Licht folgt sanft dem Cursor
       (nur Desktop mit feinem Zeiger, nicht bei reduzierter Bewegung).
   Reveal-Animationen und der Handgelenk-Rechner kommen aus at-base.js. */
(function () {
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var HOVER = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine)') : { matches: false };
  var FMT = {};
  function formatter(tz) {
    tz = tz || 'Europe/Vienna';
    if (FMT.hasOwnProperty(tz)) return FMT[tz];
    var f = null;
    try {
      f = new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
    } catch (e) {
      try { f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Vienna', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }); } catch (e2) { f = null; }
    }
    FMT[tz] = f;
    return f;
  }

  function each(root, sel, fn) { Array.prototype.forEach.call(root.querySelectorAll(sel), fn); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* (1) Uhr */
  function zoneNow(fmt) {
    var d = new Date(), h = NaN, m = NaN, s = NaN;
    if (fmt && fmt.formatToParts) {
      fmt.formatToParts(d).forEach(function (p) {
        if (p.type === 'hour') h = parseInt(p.value, 10);
        else if (p.type === 'minute') m = parseInt(p.value, 10);
        else if (p.type === 'second') s = parseInt(p.value, 10);
      });
    }
    if (isNaN(h) || isNaN(m) || isNaN(s)) { h = d.getHours(); m = d.getMinutes(); s = d.getSeconds(); }
    return { h: h % 24, m: m, s: s };
  }
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  function setRot(el, deg) { if (el) el.style.transform = 'rotate(' + deg.toFixed(3) + 'deg)'; }

  function Clock(el) {
    var self = this;
    this.el = el;
    this.hh = el.querySelector('[data-at-hand="h"]');
    this.mm = el.querySelector('[data-at-hand="m"]');
    this.ss = el.querySelector('[data-at-hand="s"]');
    this.label = el.querySelector('[data-at-clock-label]');
    this.fmt = formatter(el.getAttribute('data-at-tz'));
    this.visible = true;
    this.timer = null;
    this.last = null;
    this.rm = !!RM.matches;
    el.classList.toggle('is-rm', this.rm);
    el.classList.add('is-live');
    this.draw(true);
    if ('IntersectionObserver' in window) {
      this.io = new IntersectionObserver(function (entries) {
        self.visible = entries[entries.length - 1].isIntersecting;
        self.sync();
      });
      this.io.observe(el);
    }
    this.onVis = function () { self.sync(); };
    document.addEventListener('visibilitychange', this.onVis);
    this.onRm = function () {
      self.rm = !!RM.matches;
      el.classList.toggle('is-rm', self.rm);
      if (self.timer) { clearTimeout(self.timer); self.timer = null; }
      self.draw(true);
      self.sync();
    };
    if (RM.addEventListener) RM.addEventListener('change', this.onRm);
    else if (RM.addListener) RM.addListener(this.onRm);
    this.sync();
  }
  /* Winkel monoton über den Tag (kein Rückwärtsdrehen bei 59 → 0); Sprünge (Start, Tab zurück) ohne Transition. */
  Clock.prototype.draw = function (force) {
    var t = zoneNow(this.fmt), el = this.el;
    var total = t.h * 3600 + t.m * 60 + t.s;
    var jump = force || this.last === null || total < this.last || total - this.last > 2;
    this.last = total;
    if (jump) el.classList.add('is-jump');
    setRot(this.hh, total / 120);
    setRot(this.mm, total / 10);
    if (!this.rm) setRot(this.ss, total * 6);
    if (this.label) {
      var v = pad(t.h) + ':' + pad(t.m);
      if (this.label.textContent !== v) { this.label.textContent = v; this.label.setAttribute('datetime', v); }
    }
    if (jump) {
      void el.getBoundingClientRect();
      raf(function () { raf(function () { el.classList.remove('is-jump'); }); });
    }
  };
  Clock.prototype.sync = function () {
    var run = this.visible && !document.hidden;
    if (run && !this.timer) this.tick();
    else if (!run && this.timer) { clearTimeout(this.timer); this.timer = null; }
  };
  Clock.prototype.tick = function () {
    var self = this, period = this.rm ? 10000 : 1000;
    this.draw(false);
    this.timer = setTimeout(function () {
      self.timer = null;
      if (self.visible && !document.hidden) self.tick();
    }, period - (Date.now() % period) + 8);
  };
  Clock.prototype.destroy = function () {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
    if (this.io) this.io.disconnect();
    if (this.onVis) document.removeEventListener('visibilitychange', this.onVis);
    if (this.onRm) {
      if (RM.removeEventListener) RM.removeEventListener('change', this.onRm);
      else if (RM.removeListener) RM.removeListener(this.onRm);
    }
  };

  /* (2) Fortschrittslinie */
  function initTrack(track) {
    if (track.__atTrack) return;
    track.__atTrack = true;
    var bar = track.parentNode.querySelector('[data-at-home-progress]');
    if (!bar) return;
    var thumb = bar.firstElementChild, raf = 0;
    function update() {
      raf = 0;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) { bar.hidden = true; return; }
      bar.hidden = false;
      var ratio = track.clientWidth / track.scrollWidth;
      var p = Math.min(1, Math.max(0, track.scrollLeft / max));
      thumb.style.width = (ratio * 100).toFixed(2) + '%';
      thumb.style.left = (p * (1 - ratio) * 100).toFixed(2) + '%';
    }
    function queue() { if (!raf) raf = window.requestAnimationFrame(update); }
    track.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    update();
  }

  /* (3) Marker „Im Detail“ */
  function initDetail(root) {
    if (root.__atDetail) return;
    root.__atDetail = true;
    var pins = Array.prototype.slice.call(root.querySelectorAll('[data-at-pin]'));
    if (!pins.length) return;
    var open = null;
    function cardOf(pin) { return document.getElementById(pin.getAttribute('aria-controls')); }
    function hide(returnFocus) {
      if (!open) return;
      var pin = open, card = cardOf(pin);
      open = null;
      pin.setAttribute('aria-expanded', 'false');
      pin.parentNode.classList.remove('is-open');
      if (card) {
        card.classList.remove('is-open');
        setTimeout(function () { if (open !== pin) card.hidden = true; }, RM.matches ? 0 : 180);
      }
      if (returnFocus) { pin.__skip = true; pin.focus(); pin.__skip = false; }
    }
    function show(pin) {
      if (open === pin) return;
      hide(false);
      var card = cardOf(pin);
      if (!card) return;
      open = pin;
      pin.__t = Date.now();
      pin.setAttribute('aria-expanded', 'true');
      pin.parentNode.classList.add('is-open');
      card.hidden = false;
      void card.offsetWidth;
      card.classList.add('is-open');
    }
    pins.forEach(function (pin) {
      var wrap = pin.parentNode;
      pin.addEventListener('click', function () {
        if (open === pin && Date.now() - (pin.__t || 0) > 400) hide(false); else show(pin);
      });
      pin.addEventListener('focus', function () { if (!pin.__skip) show(pin); });
      wrap.addEventListener('focusout', function (e) {
        if (open === pin && !(e.relatedTarget && wrap.contains(e.relatedTarget))) hide(false);
      });
      if (HOVER.matches) {
        wrap.addEventListener('mouseenter', function () { show(pin); });
        wrap.addEventListener('mouseleave', function () { if (open === pin && document.activeElement !== pin) hide(false); });
      }
    });
    root.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && open) { e.preventDefault(); hide(true); }
    });
    root.__atOutside = function (e) { if (open && !open.parentNode.contains(e.target)) hide(false); };
    document.addEventListener('click', root.__atOutside);
    root.__atShow = function (el) {
      var pin = el && el.querySelector ? el.querySelector('[data-at-pin]') : null;
      if (pin) show(pin);
    };
  }

  /* (4) Spotlight: Licht folgt dem Cursor (sanft, gedämpft; nur Desktop) */
  function initSpot(sec) {
    if (sec.__atSpot) return;
    sec.__atSpot = true;
    if (!HOVER.matches || RM.matches) return;
    var tx = 50, ty = 42, cx = 50, cy = 42, frame = 0, inView = true;
    function loop() {
      frame = 0;
      cx += (tx - cx) * 0.07;
      cy += (ty - cy) * 0.07;
      sec.style.setProperty('--mx', cx.toFixed(2) + '%');
      sec.style.setProperty('--my', cy.toFixed(2) + '%');
      if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) frame = window.requestAnimationFrame(loop);
    }
    function kick() { if (!frame && inView) frame = window.requestAnimationFrame(loop); }
    sec.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var r = sec.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var px = (e.clientX - r.left) / r.width * 100, py = (e.clientY - r.top) / r.height * 100;
      tx = 50 + (px - 50) * 0.4;
      ty = 42 + (py - 42) * 0.4;
      kick();
    }, { passive: true });
    sec.addEventListener('pointerleave', function () { tx = 50; ty = 42; kick(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[en.length - 1].isIntersecting; }).observe(sec);
    }
    sec.classList.add('is-live');
  }

  function init(root) {
    root = root || document;
    each(root, '[data-at-clock]', function (el) { if (!el.__atClock) el.__atClock = new Clock(el); });
    each(root, '[data-at-home-track]', initTrack);
    each(root, '[data-at-home-detail]', initDetail);
    each(root, '[data-at-spot]', initSpot);
  }

  window.SWATHome = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    each(e.target, '[data-at-clock]', function (el) { if (el.__atClock) el.__atClock.destroy(); });
    each(e.target, '[data-at-home-detail]', function (el) { if (el.__atOutside) document.removeEventListener('click', el.__atOutside); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target && e.target.closest ? e.target.closest('[data-at-home-detail]') : null;
    if (root && root.__atShow) root.__atShow(e.target);
  });
})();